import { useEffect } from "react";
import { useNavigate, useLocation } from "@tanstack/react-router";
import { useAuth } from "@/hooks/useAuth";

/**
 * Hard-blocks every signed-in user from using the app until they reach AAL2
 * (TOTP verified). Allowed surfaces while AAL1:
 *   - /auth/mfa-setup, /auth/mfa-verify (the gates themselves)
 *   - /logout (so users can escape)
 *   - /api/* (server endpoints validate their own auth)
 *
 * Anonymous users are never redirected — public pages remain public.
 */
export function MfaEnforcer() {
  const { user, loading, mfa } = useAuth();
  const navigate = useNavigate();
  const { pathname } = useLocation();

  useEffect(() => {
    if (loading) return;
    if (!user) return;
    if (!mfa.ready) return;
    if (mfa.aal === "aal2") return;

    // Allowlisted paths while AAL1
    if (
      pathname.startsWith("/auth/mfa-") ||
      pathname === "/logout" ||
      pathname.startsWith("/api/")
    ) {
      return;
    }

    const target = mfa.needsSetup ? "/auth/mfa-setup" : "/auth/mfa-verify";
    if (pathname !== target) {
      navigate({ to: target as any, replace: true });
    }
  }, [user, loading, mfa, pathname, navigate]);

  return null;
}
